var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.is_popup_visible)?_c('popup',{attrs:{"wrapper_class":_vm.wrapper_class},on:{"close":_vm.closeModal}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.modal_content)}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }